import ORdersDashboard from "components/Dashboard/Orders";

const ORdersDashboardPage = () => {
  return <ORdersDashboard />;
};

export default ORdersDashboardPage;
